import { AutoAwesomeOutlined } from "@mui/icons-material";
import { Box, List, Typography } from "@mui/material";
import { useSampleQuestionStore } from "../../../store/home/useSampleQuestionStore";
import SuggestionItem from "./SuggestionItem";

export default function SampleQuestions() {
  const { submitQuestion, randomQuestion } = useSampleQuestionStore();
  return (
    <Box width="100%" display="flex" flexDirection="column">
      <Box display="flex" alignItems="center" gap="0.5rem" mb="0.75rem">
        <AutoAwesomeOutlined sx={{ fontSize: 18, color: "#545859" }} />
        <Typography fontSize="13px" fontWeight="medium" color="#545859">
          Suggested
        </Typography>
      </Box>
      <List disablePadding>
        {randomQuestion.map(({ title, text }) => (
          <Box sx={{ marginY: "0.5em" }}>
            <SuggestionItem key={text} title={title} text={text} onClick={submitQuestion} />
          </Box>
        ))}
      </List>
    </Box>
  );
}
